import {
  DataTable, DataTableHead, DataTableBody, DataTableRow, DataTableHeadCell, DataTableCell,
} from '@americanexpress/dls-react';
import React from 'react';

export function CommonTable({
  columns, data, tableID, emptyContent,
}) {
  const getCellValue = (column, row) => {
    if (typeof column.valueGetter === 'function') {
      return column.valueGetter(row);
    }
    if (typeof column.formatDate === 'function') {
      return column.formatDate(row);
    }
    return row[column.key];
  };

  return (

    <DataTable
      id={tableID}
      borders="all"
    >
      <DataTableHead>
        <DataTableRow id="table-head-row">

          {columns.map((column) => (
            <DataTableHeadCell key={`${tableID}-${column.header}`} id={`${tableID}-${column.header}`}>
              {column.header}
            </DataTableHeadCell>
          ))}

        </DataTableRow>

      </DataTableHead>

      <DataTableBody>
        {data.length === 0 && emptyContent ? (
          <DataTableRow id={`${tableID}-empty-row`}>
            <DataTableCell colSpan={columns.length}>
              {emptyContent}
            </DataTableCell>
          </DataTableRow>
        ) : data.map((row) => {
          const rowKey = row.vrp_consent_id || row.bank_reference;

          return (
            <DataTableRow key={rowKey} id={rowKey}>
              {columns.map((column) => (
                <DataTableCell key={column.key}>
                  {getCellValue(column, row)}
                </DataTableCell>
              ))}
            </DataTableRow>
          );
        })}

      </DataTableBody>

    </DataTable>

  );
}
